var N = Object.defineProperty, h = Object.defineProperties;
var B = Object.getOwnPropertyDescriptors;
var r = Object.getOwnPropertySymbols;
var l = Object.prototype.hasOwnProperty, i = Object.prototype.propertyIsEnumerable;
var m = (s, t, a) => t in s ? N(s, t, { enumerable: !0, configurable: !0, writable: !0, value: a }) : s[t] = a, e = (s, t) => {
  for (var a in t || (t = {}))
    l.call(t, a) && m(s, a, t[a]);
  if (r)
    for (var a of r(t))
      i.call(t, a) && m(s, a, t[a]);
  return s;
}, n = (s, t) => h(s, B(t));
var p = (s, t) => {
  var a = {};
  for (var o in s)
    l.call(s, o) && t.indexOf(o) < 0 && (a[o] = s[o]);
  if (s != null && r)
    for (var o of r(s))
      t.indexOf(o) < 0 && i.call(s, o) && (a[o] = s[o]);
  return a;
};
import { jsx as P } from "react/jsx-runtime";
import "react";
import { b as R } from "./get-size-Bc1Pz5yf.js";
import { c as _ } from "./create-vars-resolver-Bzbn9G-G.js";
import { f as b, u as V, B as q } from "./factory-ueRxoNOV.js";
import { u as w } from "./use-styles-DToiHEa6.js";
var f = { root: "m_6d731127" };
const z = {
  gap: "md",
  align: "stretch",
  justify: "flex-start"
}, A = _((s, { gap: t, align: a, justify: o }) => ({
  root: {
    "--stack-gap": R(t),
    "--stack-align": a,
    "--stack-justify": o
  }
})), u = b((s, t) => {
  const a = V("Stack", z, s), c = a, {
    classNames: o,
    className: y,
    style: g,
    styles: S,
    unstyled: k,
    vars: v,
    align: C,
    justify: D,
    gap: E,
    variant: d
  } = c, j = p(c, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "align",
    "justify",
    "gap",
    "variant"
  ]), x = w({
    name: "Stack",
    props: a,
    classes: f,
    className: y,
    style: g,
    classNames: o,
    styles: S,
    unstyled: k,
    vars: v,
    varsResolver: A
  });
  return /* @__PURE__ */ P(q, e(n(e({ ref: t }, x("root")), { variant: d }), j));
});
u.classes = f;
u.displayName = "@mantine/core/Stack";
export {
  u as S
};
